import { useMemo } from 'react';
import intl from 'react-intl-universal';
import { EDIT_BUDGET_TABS } from '../../../utils/constants';
import { Option } from '../../../utils/customTypes';

const useBudgetViewOptions = (): Option[] => {
  return useMemo(
    () => [
      {
        label: `${intl.get('BUDGET_PAGE.EDIT.TABS.TEAMS')} ${intl.get(
          'BUDGET_PAGE.EDIT.TABS.COMMON'
        )}`,
        value: EDIT_BUDGET_TABS.TEAMS,
      },
      {
        label: `${intl.get(
          'BUDGET_PAGE.EDIT.TABS.PROGRAM_OR_PROJECT'
        )} ${intl.get('BUDGET_PAGE.EDIT.TABS.COMMON')}`,
        value: EDIT_BUDGET_TABS.PROGRAM_OR_PROJECT,
      },
      {
        label: `${intl.get('BUDGET_PAGE.EDIT.TABS.VENDORS')} ${intl.get(
          'BUDGET_PAGE.EDIT.TABS.COMMON'
        )}`,
        value: EDIT_BUDGET_TABS.VENDORS,
      },
    ],
    []
  );
};

export default useBudgetViewOptions;
